/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateClassifierRequest
 */
export interface UpdateClassifierRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateClassifierRequest
     */
    classifierType?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateClassifierRequest
     */
    classifierParams?: { [key: string]: any; } | null;
}

/**
 * Check if a given object implements the UpdateClassifierRequest interface.
 */
export function instanceOfUpdateClassifierRequest(value: object): value is UpdateClassifierRequest {
    return true;
}

export function UpdateClassifierRequestFromJSON(json: any): UpdateClassifierRequest {
    return UpdateClassifierRequestFromJSONTyped(json, false);
}

export function UpdateClassifierRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClassifierRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'classifierType': json['classifier_type'] == null ? undefined : json['classifier_type'],
        'classifierParams': json['classifier_params'] == null ? undefined : json['classifier_params'],
    };
}

export function UpdateClassifierRequestToJSON(json: any): UpdateClassifierRequest {
    return UpdateClassifierRequestToJSONTyped(json, false);
}

export function UpdateClassifierRequestToJSONTyped(value?: UpdateClassifierRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classifier_type': value['classifierType'],
        'classifier_params': value['classifierParams'],
    };
}

